module.exports = __webpack_public_path__ + "img/blurred_deals_tools.b1f02957.jpg";